import React from 'react';
import { Heart, Wine, Music, Bus } from 'lucide-react';
import './Schedule.css';

const Schedule = () => {
    const events = [
        { time: '5:30 PM', title: 'Ceremony', desc: 'The exchange of vows.', icon: <Heart size={28} /> },
        { time: '6:00 PM', title: 'Cocktail Hour', desc: 'Drinks and hors d\'oeuvres.', icon: <Wine size={28} /> },
        { time: '7:00 PM', title: 'Reception', desc: 'Dinner, dancing, and celebration!', icon: <Music size={28} /> },
    ];

    return (
        <div className="schedule-wrapper">
            <section id="schedule" className="section-container schedule-section">
                <h2 className="section-title">Schedule</h2>
                <div className="schedule-grid">
                    {events.map((event, index) => (
                        <div key={index} className="schedule-card">
                            <div className="schedule-icon">
                                {event.icon}
                            </div>
                            <h3 className="schedule-title">{event.title}</h3>
                            <p className="schedule-time">{event.time}</p>
                            <p className="schedule-desc">{event.desc}</p>
                        </div>
                    ))}
                </div>
                <div className="schedule-shuttle-note">
                    <Bus size={22} className="shuttle-note-icon" />
                    <span>
                        <strong>Guest Shuttle:</strong> Departs hotel at <strong>4:30 PM</strong> &bull; Returns from venue at <strong>10:15 PM</strong> &amp; <strong>11:00 PM</strong>.
                        <a href="#lodging" className="shuttle-note-link"> See travel details &rarr;</a>
                    </span>
                </div>
            </section>
        </div>
    );
};

export default Schedule;
